// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"containers_wrapper__2JGLR","row":"containers_row__1WxWa"};